import React, { useEffect, useState, useCallback } from "react";
import { tokens } from "../../Theme";
import { BarChart } from '@mui/x-charts/BarChart';
import { Button, Typography, Box, useTheme, ButtonGroup } from '@mui/material';
import { getScreenUsageCountByTimeRange } from '../../api/helpers';

const chartSetting = {
  width: 1000,
  height: 500,
};

const valueFormatter = (value: number | null) => `${value}`;

export function AllScreens() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([
    { screen: 'Home', count: 0 },
    { screen: 'MicroTrendsScreen', count: 0 },
    { screen: 'MacroTrendsScreen', count: 0 },
    { screen: 'Hive', count: 0 },
    { screen: 'DailyInfoScreen', count: 0 },
  ]);
  const [timeRange, setTimeRange] = useState('last_24_hours');

  const fetchScreenUsageCounts = useCallback(async () => {
    const homeScreenCount = await getScreenUsageCountByTimeRange('Home', timeRange);
    const hiveScreenCount = await getScreenUsageCountByTimeRange('Hive', timeRange);
    const microTrendsScreen = await getScreenUsageCountByTimeRange('MicroTrendsScreen', timeRange);
    const macroTrendsScreen = await getScreenUsageCountByTimeRange('MacroTrendsScreen', timeRange);
    const dailyInfoScreenCount = await getScreenUsageCountByTimeRange('DailyInfoScreen', timeRange);

    setData([
      { screen: 'DailyInfoScreen', count: dailyInfoScreenCount?.dailyinfoscreen_usage_count || 0 },
      { screen: 'Home', count: homeScreenCount?.home_usage_count || 0 },
      { screen: 'MicroTrendsScreen', count: microTrendsScreen?.microtrendsscreen_usage_count || 0 },
      { screen: 'MacroTrendsScreen', count: macroTrendsScreen?.macrotrendsscreen_usage_count || 0 },
      { screen: 'Hive', count: hiveScreenCount?.hive_usage_count || 0 },
    ]);
  }, [timeRange]);

  useEffect(() => {
    fetchScreenUsageCounts();
  }, [timeRange, fetchScreenUsageCounts]);

  const handleButtonClick = (selectedTimeRange: string) => {
    setTimeRange(selectedTimeRange);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography variant="h3" align="center" gutterBottom>
        SCREEN USAGE ({timeRange.replace('_', ' ').replace('_', ' ').toUpperCase()})
      </Typography>
      <ButtonGroup variant="contained" aria-label="outlined primary button group"
        sx={{ backgroundColor: theme.palette.success.main, color: theme.palette.grey[100], mt: 2, mb: 2 }}>
        <Button
          onClick={() => handleButtonClick('last_24_hours')}
          sx={{
            backgroundColor: timeRange === 'last_24_hours' ? colors.greenAccent[500] : colors.greenAccent[600],
            color: colors.grey[100],
            '&:hover': {
              backgroundColor: colors.greenAccent[500],
            },
          }}
        >
          Last 24 Hours
        </Button>
        <Button
          onClick={() => handleButtonClick('this_week')}
          sx={{
            backgroundColor: timeRange === 'this_week' ? colors.greenAccent[500] : colors.greenAccent[600],
            color: colors.grey[100],
            '&:hover': {
              backgroundColor: colors.greenAccent[500],
            },
          }}
        >
          This Week
        </Button>
        <Button
          onClick={() => handleButtonClick('this_month')}
          sx={{
            backgroundColor: timeRange === 'this_month' ? colors.greenAccent[500] : colors.greenAccent[600],
            color: colors.grey[100],
            '&:hover': {
              backgroundColor: colors.greenAccent[500],
            },
          }}
        >
          This Month
        </Button>
      </ButtonGroup>
      <BarChart
        dataset={data}
        xAxis={[{ scaleType: 'band', dataKey: 'screen', label: 'SCREENS' }]}
        yAxis={[{ label: 'USERS' }]}
        series={[{ dataKey: 'count', label: 'USERS', valueFormatter }]}
        layout="vertical"
        {...chartSetting}
      />
    </Box>
  );
}

export default AllScreens;
